type Listener = (pending: boolean) => void

const listeners = new Set<Listener>()

export function subscribeNavigationLoading(listener: Listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function startNavigationLoading() {
  listeners.forEach(listener => listener(true))
}

export function stopNavigationLoading() {
  listeners.forEach(listener => listener(false))
}
